import React from "react";
import PropTypes from "prop-types";
import cn from "./style.module.scss";

export function Title(props) {
  const className = `${cn.title} ${props.className}`;
  return <h3 className={className}>Experiment design complete!</h3>;
}

Title.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
};

Title.defaultProps = {
  className: "",
};
